import './report.scss';

export default () => {

};
